import { Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2 } from '@angular/core';
import {LocalesService, ConfigService} from '../templates/Locale/locales.service';
import { Locale } from '../templates/Locale/Locale';
import { Subscription } from 'rxjs';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ standalone: true, selector: '[localeplaceholder]' })

export class LocalePlaceholderDirective implements OnChanges, OnDestroy {
  @Input('localeplaceholder') localePlaceHolderKey!: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('localeview') localePlaceHolderView!: string;

  private subscription?: Subscription;

    constructor(private el: ElementRef, private renderer2: Renderer2, private localeService: LocalesService, private configService: ConfigService) { }

  ngOnChanges(): void {
    this.subscription?.unsubscribe();
    this.subscription = this.localeService.getLocalesByLang(this.configService.languagerequested)
      .subscribe({
        next: (locales: Locale[]) => {
          const match = locales.find(item =>
            item.key === this.localePlaceHolderKey && (item.view == null || item.view === this.localePlaceHolderView)
          );
          this.renderer2.setAttribute(this.el.nativeElement, 'placeholder', match?.value ?? '');
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}

